module.exports = __webpack_public_path__ + "14393fed10c99657fe569592b146a2c9.svg";